import { render, staticRenderFns } from "./quickPay.vue?vue&type=template&id=4979e0e4&scoped=true&"
import script from "./quickPay.vue?vue&type=script&lang=js&"
export * from "./quickPay.vue?vue&type=script&lang=js&"
import style0 from "./quickPay.vue?vue&type=style&index=0&id=4979e0e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979e0e4",
  null
  
)

export default component.exports